import { useContext } from 'react';

import type { ApiClient } from './ApiClient';
import { ApiContext } from './ApiContext';

export const useApi = (context = ApiContext): ApiClient => {
  const client = useContext(context);

  if (!client) {
    throw new Error('You forgot to wrap your component in <ApiProvider>.');
  }

  return client;
};
